﻿import { defineComponent, PropType } from 'vue';

import { passenger } from "../../objects/v1_2/Booking/Passenger";
import { trip_passenger } from "../../objects/v1_2/Booking/Trip_Passenger";

import { Booking } from "../../services/booking";

const Book = new Booking();

export default defineComponent({
    name: "existing_passengers",
    props: {
        passengers: { type: Array as PropType<passenger[]>, default: [] },
    },
    data() {
        return {
            isHidden: true,
            selected_passengers: [] as trip_passenger[],
            addingAddon: false
        }
    },
    methods: {
        Passenger_Selected(Passenger: passenger): boolean {
            return Book.Existing_Passenger_Added(this.$store.getters.get_Basket, Passenger);
       },
        Toggle_Passenger(Passenger: passenger) {
            this.$store.commit("Passenger_Toggle", { Passenger: Passenger });
        }
    },
    mounted() {
    }
})